import { Component, inject, OnInit } from '@angular/core';
import {
	FormControl,
	FormGroup,
	FormsModule,
	ReactiveFormsModule,
	Validators,
} from '@angular/forms';
import { PortalInvitee } from '@models/portal-invites';
import { dispatch } from '@ngxs/store';
import { MODAL_DATA } from '@ui/modal/modal-data.token';
import { AtomicModule } from 'src/app/shared/atomic/atomic.module';
import { SnackbarService } from 'src/app/shared/services/ui/snackbar.service';
import { OverwritePersonClientFields } from 'src/app/shared/state/clients/clients.actions';
import { UpdateInviteeEmail } from 'src/app/shared/state/portal-invite/portal-invite.actions';
import { ModalService } from 'src/app/ui/modal/modal.service';
import { removeUppercaseAndSpaces } from '@globalUtils/utilities';

@Component({
	selector: 'app-update-client-email-modal',
	templateUrl: './update-client-email-modal.component.html',
	standalone: true,
	imports: [AtomicModule, FormsModule, ReactiveFormsModule],
})
export class UpdateClientEmailModalComponent implements OnInit {
	form = new FormGroup({
		email: new FormControl(null, [Validators.required, Validators.email]),
	});

	data = inject(MODAL_DATA) as { invitee: PortalInvitee; inviteId: string };
	modalService = inject(ModalService);
	snackbarService = inject(SnackbarService);

	overwritePersonClientFields = dispatch(OverwritePersonClientFields);
	updateInviteeEmail = dispatch(UpdateInviteeEmail);

	ngOnInit(): void {
		this.modalService.setPrimaryAction('Update', () => {
			this.form.markAllAsTouched();
			if (this.form.invalid) return;

			const newEmail = removeUppercaseAndSpaces(this.form.get('email')?.value);

			this.overwritePersonClientFields({
				clientId: this.data.invitee.clientId,
				field: 'email',
				value: newEmail,
			});

			this.updateInviteeEmail({
				inviteId: this.data.inviteId,
				newEmail: newEmail,
				clientId: this.data.invitee.clientId,
			});

			this.snackbarService.openSnackBar({
				text: `${this.data.invitee.name}'s email address is updated`,
				type: 'success',
			});

			this.modalService.closeModal();
		});
	}
}
